export const homeURL = "/";

